import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import {
	type AuthState,
	type StartLoginPayload,
	type VerifyOtpPayload,
} from "../types/auth.types";

const initialState: AuthState = {
	loading: false,
	step: 1,
	token: null,
	refreshtoken: "",
	tempSessionId: null,
	error: null,
	otpVerified: false,
	recaptchaToken: "",
};

const authSlice = createSlice({
	name: "auth",
	initialState,
	reducers: {
		// Step 1 actions
		startLoginRequest: (state, _: PayloadAction<StartLoginPayload>) => {
			state.loading = true;
			state.error = null;
		},
		startLoginSuccess: (
			state,
			action: PayloadAction<{ sessionId: string }>
		) => {
			state.loading = false;
			state.step = 2;
			state.tempSessionId = action.payload.sessionId;
		},
		startLoginFailure: (state, action: PayloadAction<string>) => {
			state.loading = false;
			state.error = action.payload;
		},

		// Step 2 actions
		verifyOtpRequest: (state, _: PayloadAction<VerifyOtpPayload>) => {
			state.loading = true;
			state.error = null;
		},
		verifyOtpSuccess: (
			state,
			action: PayloadAction<{ token: string; refreshToken?: string }>
		) => {
			state.loading = false;
			state.token = action.payload.token;
			state.refreshtoken = action.payload.refreshToken || "";
			state.step = 3;
			state.otpVerified = true;
		},
		verifyOtpFailure: (state, action: PayloadAction<string>) => {
			state.loading = false;
			state.error = action.payload;
			state.otpVerified = false;
			state.token = null;
		},
		setRecaptchaToken: (state, action: PayloadAction<string>) => {
			state.recaptchaToken = action.payload;
		},
		refreshTokenCall: (state) => {
			state.error = null;
		},
		clearAuthError: (state) => {
			state.error = null;
			state.loading = false;
		},
	},
});

export const {
	startLoginRequest,
	startLoginSuccess,
	startLoginFailure,
	verifyOtpRequest,
	verifyOtpSuccess,
	verifyOtpFailure,
	refreshTokenCall,
	setRecaptchaToken,
	clearAuthError,
} = authSlice.actions;

export default authSlice.reducer;
